module.exports = __webpack_public_path__ + "static/media/3.470fb74a.jpg";